<template>
  <div class="BrandFamily indexMain">
    <div class="title" ref="memberContent">
      <div class="t_cn">品牌家族</div>
      <div class="t_en">BRAND FAMILY</div>
    </div>
    <div class="BrandList clear">
      <div
        class="item_Brand"
        v-for="(item, index) in brandList"
        :key="'item_Brand' + index"
      >
        <router-link :to="'/product-detail?id=' + item.id">
          <div class="i_cont">
            <img :src="item.logoSrc" alt="BrandImg1" />
            <div class="i_title">{{ item.title }}</div>
          </div>
          <div class="i_info">
            <div class="i_tit">{{ item.title }}</div>
            <i></i>
            <div class="i_text">{{ item.desc }}</div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      brandList: [
        {
          id: 0,
          logoSrc: require("../../assets/images/company/CompanyProfile/BrandImg1.png"),
          title: "广达牌樟脑",
          info: "广达牌樟脑介绍",
          desc: "本品为白色结晶性粉末或无色半透明的硬块，味初辛、后清凉；主要用作医药原料，如皮肤刺激药、生产樟脑磺酸钠。",
        },
        {
          id: 1,
          logoSrc: require("../../assets/images/company/CompanyProfile/BrandImg2.png"),
          title: "白雪牌冰片",
          info: "白雪牌冰片介绍",
          desc: "本品为无色透明或半透明的片状松脆结晶；气清香，味辛、凉；在中医药中用于治疗热病神昏、惊厥、中风痰厥、气郁暴厥、中恶昏迷、目赤、口疮、咽喉肿痛、耳道流脓等症状，冰片还是良好的食品、日常护理品和香精香料的原料。",
        },
        {
          id: 4,
          logoSrc: require("../../assets/images/company/CompanyProfile/BrandImg3.png"),
          title: "三春牌醋酸钠",
          info: "三春牌醋酸钠介绍",
          desc: "本产品为无色或白色晶体，暴露于潮湿空气中易潮解，于干燥空气中易风化。主要用于印染工业、医药、照相、电镀、化学试剂及有机合成的生产等。",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.BrandList {
  position: relative;
  .item_Brand {
    $item_Brand_width: 23.18vw;
    $item_Brand_height: 12.81vw;
    float: left;
    width: $item_Brand_width;
    height: $item_Brand_height;
    margin: 0 1.56vw 0 0;
    position: relative;
    cursor: pointer;
    &:nth-child(3n) {
      margin: 0 0 0 0;
    }
    &:hover {
      .i_info {
        z-index: 66;
      }
    }
    .i_cont {
      width: $item_Brand_width - 4.17vw;
      height: $item_Brand_height - 3.13vw;
      padding: 1.56vw 2.08vw;
      position: absolute;
      top: 0;
      left: 0;
      background-color: #eeeeee;
      img {
        display: block;
        height: 3.8vw;
        margin: 1.04vw auto 0;
      }
      .i_title {
        padding: 1.56vw 0 0 0;
        font-size: 1.25vw;
        color: #333333;
        text-align: center;
      }
    }
    .i_info {
      width: $item_Brand_width - 4.17vw;
      height: $item_Brand_height - 3.13vw;
      padding: 1.56vw 2.08vw;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -6;
      background-color: #87c31e;
      i {
        display: block;
        width: 2.08vw;
        height: 0.31vw;
        background-color: #ffffff;
        border-radius: 0.16vw;
        margin: 0.83vw 0 1.35vw;
      }
      .i_tit {
        color: #ffffff;
        font-size: 1.25vw;
        line-height: 1.56vw;
      }
      .i_text {
        color: #ffffff;
        font-size: 0.83vw;
        line-height: 1.25vw;
      }
    }
  }
}
@media (min-width: 1920px) {
  .BrandList {
    position: relative;
    .item_Brand {
      $item_Brand_width: 445px;
      $item_Brand_height: 246px;
      float: left;
      width: $item_Brand_width;
      height: $item_Brand_height;
      margin: 0 30px 0 0;
      position: relative;
      cursor: pointer;
      &:nth-child(3n) {
        margin: 0 0 0 0;
      }
      &:hover {
        .i_info {
          z-index: 66;
        }
      }
      .i_cont {
        width: $item_Brand_width - 80px;
        height: $item_Brand_height - 60px;
        padding: 30px 40px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: #eeeeee;
        img {
          display: block;
          height: 73px;
          margin: 20px auto 0;
        }
        .i_title {
          padding: 30px 0 0 0;
          font-size: 24px;
          color: #333333;
          text-align: center;
        }
      }
      .i_info {
        width: $item_Brand_width - 80px;
        height: $item_Brand_height - 60px;
        padding: 30px 40px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -6;
        background-color: #87c31e;
        i {
          display: block;
          width: 40px;
          height: 6px;
          background-color: #ffffff;
          border-radius: 3px;
          margin: 16px 0 26px;
        }
        .i_tit {
          color: #ffffff;
          font-size: 24px;
          line-height: 30px;
        }
        .i_text {
          color: #ffffff;
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
  }
}
</style>